import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {logout, setCredentials} from "../../features/auth/authSlice";
import {config} from "../config";

const baseQuery = fetchBaseQuery({
    // Раньше здесь был захардкожен локальный IP (192.168.88.206), из-за чего
    // refresh-token уходил не на прод. Теперь адрес берётся из конфигурации.
    baseUrl: config.apiBaseUrl,
    credentials: "include",
    prepareHeaders: (headers, {getState}) => {
        const token = getState().auth.token;
        if(token){
            headers.set("authorization", `Bearer ${token}`)
        }
        return headers;
    }

})


const isAuthEndpoint = (args) => {
    const url = typeof args === "string" ? args : args?.url || "";
    return url.includes("/api/v2/askCode") || url.includes("/api/v2/login");
};

// Один refresh на все параллельные 401: иначе ротация токена превращается в
// гонку, где второй запрос инвалидирует токен, только что полученный первым.
let refreshPromise = null;

const refreshAccessToken = (refreshToken, api, extraOptions) => {
    if (!refreshPromise) {
        refreshPromise = (async () => {
            const refreshResult = await baseQuery({
                url: "/api/v2/refreshtoken",
                method: "POST",
                body: JSON.stringify({refreshToken}),
                headers: {"Content-Type": "application/json"}
            }, api, extraOptions);

            const newToken = refreshResult?.data?.jwt || refreshResult?.data?.token;
            if (newToken) {
                // Обновляем store внутри общего промиса: иначе второй 401,
                // пришедший сразу после refresh, прочитает старый токен.
                const currentUser = api.getState().auth.user;
                api.dispatch(setCredentials({
                    user: refreshResult.data.user || currentUser,
                    jwt: newToken,
                    refreshToken: refreshResult.data.refreshToken || refreshToken
                }));
            }
            return refreshResult;
        })().finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // ✅ ПРАВИЛЬНАЯ ПРОВЕРКА 401
    // Не пытаемся обновлять токен на самих эндпоинтах входа: 401 там означает
    // «неверный email/пароль/код», а не истёкшую сессию.
    if (result?.error?.status === 401 && !isAuthEndpoint(args)) {
        console.log("Sending refresh token");

        const state = api.getState().auth;
        const refreshToken = state.refreshToken;

        if (!refreshToken) {
            console.log("No refresh token, logging out");
            api.dispatch(logout());
            return result;
        }

        const refreshResult = await refreshAccessToken(refreshToken, api, extraOptions);

        // Бэкенд v2 отвечает { jwt, refreshToken, expiresIn, user }; refresh-токен
        // ротируется. Store уже обновлён внутри refreshAccessToken.
        const newToken = refreshResult?.data?.jwt || refreshResult?.data?.token;

        if (newToken) {
            // Повторяем исходный запрос с новым токеном
            result = await baseQuery(args, api, extraOptions);
        } else {
            console.log("Refresh failed, logging out");
            api.dispatch(logout());
        }
    }

    return result;
};


export const apiSlice = createApi({
    reducerPath: 'api',
    tagTypes: [
        'Cat4Results',
        'Results',
        'Articles',
        'Tags',
        'Categories',
        'CandidateTypes',
        'Locations',
        'Programs',
        'Roles',
        'Countries',
        'Candidates',
        'Residences',
        'Gender_Information_For_School',
        'Maps',
        'Schools',
        'SchoolTypes',
        'Celebrities',
        'Faculties',
        'Requests',
        'Clients',
        'Users',
        'Tests',
        'QuizQuestions',
        'QuizOptions',
        'ResultsForAdmin',
        'MailingTypes',
        'EmailMessages',
        'Headers',
        'Footers',
        'Mailings',
        'Subscribers',
        'SubscriberLists',
        'MailingTypes',
        'Mailings',
        'MailLogs',
        'QueueMails',
        'EssayConversations',
        'Orders',
        'LanguageLevelResults',
        'Errors',
        'NotificationLeads',
        'OfflineConversions',
        'ChatArchive',
        'ChatBanned',
        'ChatPrompts',
        'ChatPageTags',
        'Banners',
        'BannerStats'
    ],
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})